<style scoped lang="scss" type="text/scss">

</style>

<template>
    <div class="global-relative">
        <loading-placeholder :loading="loading"></loading-placeholder>

        <el-table :data="data" stripe border size="small" style="width: 100%">
            <el-table-column type="index" label="序号" align="center" width="80"></el-table-column>
            <el-table-column prop="name" label="赛事名称" align="center" min-width="120"></el-table-column>
            <el-table-column prop="year_text" label="赛事年份" align="center" min-width="70"></el-table-column>
            <el-table-column prop="theme" label="赛事主题" align="center" min-width="100"></el-table-column>
            <el-table-column prop="venue_full_name" label="举办地址" align="center"
                             min-width="120"></el-table-column>
            <el-table-column prop="start_time_text" label="比赛开始时间" align="center"
                             width="100"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        name: '',
        props: {
            data: {
                type: Array,
                default: () => []
            },
            loading: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {};
        },
        methods: {
            apply () {
            }
        }
    };
</script>
